import { CanDeactivateFn } from '@angular/router';
import { RequirementFormComponent } from './requirement-form.component';

export const canDeactivateRequirementForm: CanDeactivateFn<RequirementFormComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
